// A small helper class that accumulates satisfied conditions, and then evaluates
// whether a set of conditions have all been satisfied.  Unknown conditions are
// skipped.  The accumulated satisfied conditions can be cleared at any time.
var ConditionsChecker = /** @class */ (function () {
    function ConditionsChecker(knownConditions) {
        this.currentSatisfiedConditions = [];
        this.knownConditions = knownConditions;
    }
    // Reset the accumulated conditions.
    ConditionsChecker.prototype.clear = function () {
        this.currentSatisfiedConditions = [];
    };
    // Accumulate a satisfied condition.
    ConditionsChecker.prototype.addSatisfiedCondition = function (id) {
        this.currentSatisfiedConditions.push(id);
    };
    // Check whether the current set of satisfied conditions satisfy the given
    // required conditions.
    ConditionsChecker.prototype.checkRequirementConditions = function (requiredConditions) {
        for (var _i = 0, requiredConditions_1 = requiredConditions; _i < requiredConditions_1.length; _i++) {
            var requiredCondition = requiredConditions_1[_i];
            // If we don't yet support a condition, don't check against it for now.
            if (!Object.values(this.knownConditions).includes(requiredCondition)) {
                continue;
            }
            // Not satisfying a required condition is a fail.
            if (!this.currentSatisfiedConditions.includes(requiredCondition)) {
                return false;
            }
        }
        // All conditions are satisfied.
        return true;
    };
    return ConditionsChecker;
}());
export default ConditionsChecker;
